import React from "react";
import * as constants from '../constants';
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingRange from "../../../../UI/Settings/CPSettingRange";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingColor from "../../../../UI/Settings/CPSettingColor";

const PopUpEpisode = ({settings, onChange}) => {
    return (
        <>
            <CPSettingRange
                name={constants.SCHEDULE_EPISODE_POPUP_OPACITY}
                value={settings?.[constants.SCHEDULE_EPISODE_POPUP_OPACITY] ?? 80}
                defaultValue={80}
                label="Прозрачность фона"
                step={5}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.SCHEDULE_EPISODE_POPUP_BLUR}
                label="Размытие фона"
                eventValue={settings?.[constants.SCHEDULE_EPISODE_POPUP_BLUR]}
                defaultValue={'10px'}
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_EPISODE_POPUP}
                isChecked={settings?.[constants.SCHEDULE_SHOW_EPISODE_POPUP]}
                label="Показывать поп-ап"
                onChange={onChange}
            />
            {
                settings?.[constants.SCHEDULE_SHOW_EPISODE_POPUP] &&
                <>
                    <CPSettingToggle
                        name={constants.SCHEDULE_EPISODE_POPUP_SHOW_FORMAT}
                        isChecked={settings?.[constants.SCHEDULE_EPISODE_POPUP_SHOW_FORMAT]}
                        label="Показывать формат"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name={constants.SCHEDULE_EPISODE_POPUP_SHOW_STATUS}
                        isChecked={settings?.[constants.SCHEDULE_EPISODE_POPUP_SHOW_STATUS]}
                        label="Показывать статус"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name={constants.SCHEDULE_EPISODE_POPUP_WATCH_EPISODE}
                        isChecked={settings?.[constants.SCHEDULE_EPISODE_POPUP_WATCH_EPISODE]}
                        label="Показывать кнопку 'Смотреть'"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name={constants.SCHEDULE_EPISODE_POPUP_ADD_TO_CALENDAR}
                        isChecked={settings?.[constants.SCHEDULE_EPISODE_POPUP_ADD_TO_CALENDAR]}
                        label="Показывать кнопку 'Добавить в календарь'"
                        onChange={onChange}
                    />
                    <CPSettingColor
                        name="popupBackgroundColor"
                        label="Цвет фона модального окна"
                        eventColor={settings?.popupBackgroundColor}
                        defaultColor="#FFFFFF"
                        onChange={onChange}
                    />
                    <CPSettingColor
                        name="popupTextColor"
                        label="Цвет текста модального окна"
                        eventColor={settings?.popupTextColor}
                        defaultColor="#000000"
                        onChange={onChange}
                    />
                </>
            }
        </>
    );
};

export default PopUpEpisode;
